export default {
  plural: 'Twin-материалы',
  createButton: 'Создать материал',
  createTitle: 'Добавить материал',
  editTitle: 'Редактировать материал',
  deleteTitle: 'Удалить материал',
  deleteWarning: 'Вы уверены, что хотите удалить этот материал?',
  company: 'Компания',
  crmMaterial: 'CRM-материал',
  glbAsset: 'GLB-ассет',
  glbMaterialName: 'GLB-материал',
  swatchColor: 'Цвет свотча',
  materialGroup: 'Группа материала',
  noMaterials: 'Материалов пока нет',
  addMaterial: 'Добавить материал',
  backendBlocked: 'Ожидает поддержки бэкенда',
  bulkAddButton: 'Массовое добавление',
  bulkCreateTitle: 'Массовое добавление материалов',
  crmMaterials: 'CRM-материалы',
  noGroup: 'Без группы',
  searchPlaceholder: 'Поиск зоны...',
  selectZone: 'Выберите зону слева, чтобы настроить её материалы',
  allowedCount: 'разрешено',
  zones: {
    plural: 'Zones',
    noZones: 'Зон пока нет — распознайте GLB-ассет с мешами twinZone',
    noTemplate: 'Нет шаблона зоны — создайте, чтобы зона стала доступна',
    noMaterials: 'Для этой зоны нет разрешённых материалов',
    createTemplate: 'Создать шаблон',
    save: 'Сохранить',
    setDefault: 'По умолчанию'
  }
};
